import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerificationPage from "../../../components/VerificationPage";
import { registerSupplier } from "../../../services/supplier/authenticationApiFn";
import { encryptPassword, handleOpenSnackBar } from "../../../utils";
import { companySendCode } from "../../../services/company/authenticationApiFn";

const SupplierRegistrationVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { inputValues } = state;
  const [code, setCode] = useState();
  const [isLoading, setIsLoading] = useState("");

  const handleVerify = async () => {
    const longitude = inputValues.supplierLocation?.lng;
    const latitude = inputValues.supplierLocation?.lat;

    const locationObject = {
      addressLabel: inputValues.location.label,
      formatedAddress: inputValues?.supplierLocation?.address,
      type: "Point",
      coordinates: [longitude, latitude],
    };

    const payload = {
      businessName: inputValues.name,
      businessEmail: inputValues.email,
      contact: inputValues.contact,
      location: locationObject,
      source: inputValues.source,
      profileImg: inputValues.image,
      licenseImg: inputValues.license,
      password: encryptPassword(inputValues.password),
      role: "Supplier",
      otp: code,
      cui: inputValues.cui,
    };

    try {
      setIsLoading(true);
      const response = await registerSupplier(payload);
      if (response.data.status === "success") {
        const data = response.data.data;
        navigate("/subscriptions", {
          state: { type: "supplier", user: data?._id, subscriptionId: "" },
        });
        setCode("");
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendCode = async () => {
    try {
      setIsLoading(true);
      const payload = {
        email: inputValues.email,
        purpose: "Registration",
        role: "Supplier",
        cui: inputValues.cui,
      };
      const response = await companySendCode(payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VerificationPage
      handleBack={() => {
        navigate("/register/supplier", { state: { inputValues } });
      }}
      code={code}
      setCode={setCode}
      handleClickBtn={handleVerify}
      isLoading={isLoading}
      handleSendCode={handleSendCode}
    />
  );
};

export default SupplierRegistrationVerification;
